module.exports = __webpack_public_path__ + "img/tutorial06.dbc7e0e0.png";